<div class="toolbar">
  <p-button
    label="Nueva aplicación"
    icon="pi pi-plus"
    (click)="newRecord()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="button-column"></th>

      <th pSortableColumn="code" id="code-column">
        Código <p-sortIcon field="key"></p-sortIcon>
      </th>
      <th pSortableColumn="description" id="description-column">
        Descripción <p-sortIcon field="title"></p-sortIcon>
      </th>
      <th pSortableColumn="createdAt" id="createdAt-column">
        Creado <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td>{{ record.code }}</td>
      <td>{{ record.description }}</td>
      <td>{{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}</td>
    </tr>
  </ng-template>
</p-table>
